// extracted by mini-css-extract-plugin
module.exports = {"root":"s_bJ"};